import { SET_WEIGHT_TOLERANCES } from '../types/weightTolerance'

const initState = {
  tolerances: {},
  lastModified: new Date().getTime(),
}

const weightToleranceReducer = (state = initState, action = {}) => {
  const { type, payload } = action

  switch (type) {
    case SET_WEIGHT_TOLERANCES:
      return { ...state, tolerances: payload.tolerances, lastModified: new Date().getTime() }
    default:
      return state
  }
}

export default weightToleranceReducer



// WEBPACK FOOTER //
// ./src/reducers/weightTolerance.js